/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import './style/passwordRules.scss';

import React from 'react';
import classNames from 'classnames';
import {PasswordRule} from "../../util/interfaces";

interface Props {
    password: string;
    visible: boolean;
    rules: PasswordRule[];
    containerClass?: string;
    ruleClass?: string;
}

const DEFAULT_RULES: PasswordRule[] = [
    {label: 'Minimaal 8 tekens', validator: (password: string) => password.length >= 8},
    {label: 'Maximaal 24 tekens', validator: (password: string) => password.length <= 24},
    {label: 'Minimaal 1 getal', validator: (password: string) => /\d/.test(password)},
    {label: 'Minimaal 1 symbool', validator: (password: string) => /[!?@#$%^&*(),./\[\]{}]/.test(password)},
    {label: 'Minimaal 1 hoofdletter', validator: (password: string) => /[A-Z]/.test(password)},
];

export default class PasswordRules extends React.Component<Props> {
    static defaultProps = {
        containerClass: '',
        ruleClass: '',
        rules: DEFAULT_RULES,
    };

    renderRule = (rule: PasswordRule, index: number) => {
        const {password, ruleClass} = this.props, rulePassed = rule.validator(password);
        return <label key={index} className={classNames('rule-label', rulePassed && 'passed',
            !rulePassed && 'failed', ruleClass)}>- {rule.label}</label>;
    };

    render = () => {
        const {containerClass, visible, password, rules} = this.props, hidden = !visible || !password.length;
        return (
            <div className={classNames('password-rules-container', hidden && 'hidden', containerClass)}>
                {rules.map(this.renderRule)}
            </div>
        )
    };
}